const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

const request = async (method, endpoint = '', body = null) => {
  try {
    const token = localStorage.getItem('AccessToken');

    const headers = {
      'Content-Type': 'application/json',
      'AccessToken': token ? `Bearer ${token}` : '',
    };

    const options = { method, headers };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${BASE_URL}${endpoint}`, options);

    const data = await response.json().catch(() => ({}));

    if (response.status === 401 || data.code === 401) {
      if(data.message?.includes("ExpiredJwtToken")) {
        alert(data.message);
        localStorage.removeItem('AccessToken');
        window.location.href = '/login';
        return null;
      }
      window.location.href = '/admin';
      alert("권한이 없습니다.");
      // window.location.href = '/';
      // return null;
      return { unauthorized: true };
    }

    if (data.code !== 200) {
      alert(data.message || '요청 처리 중 문제가 발생했습니다.');
      // window.location.href = '/';
      return null;
    }

    if (!response.ok) {
      throw new Error(data.message || 'API 요청 중 오류 발생');
    }

    return data;

  } catch (error) {
    console.error(`${method} API 호출 실패:`, error);
    alert(error.message || '네트워크 오류');
    return null;
  }
};

const api = {
  get: (url) => request('GET', url),
  post: (url, body) => request('POST', url, body),
  patch: (url, body) => request('PATCH', url, body),
  delete: (url, body) => request('DELETE', url, body),
};

export default api;